import { useCurrency } from "../lib/currency";
import { MessageCircle, Package } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Card for a single variant (used on public store category view).
 * variant = { id, name, sale_price, image_base64, ... }
 * product = parent product (for name, category, fallback image, WhatsApp text)
 */
export default function VariantCard({ product, variant }) {
  const { format, whatsapp } = useCurrency();

  const buildWaLink = () => {
    const phone = (whatsapp || "").replace(/\D/g, "");
    const text = encodeURIComponent(
      `Olá Ladybeauty! Gostaria de encomendar:\n• ${variant.name} — ${product.name}\nPreço: ${format(variant.sale_price)}`
    );
    return `https://wa.me/${phone}?text=${text}`;
  };

  return (
    <article
      className="group bg-white rounded-2xl overflow-hidden lb-shadow-card lb-hover-lift lb-fade-in"
      data-testid={`variant-card-${variant.id}`}
    >
      <div className="aspect-square bg-[hsl(var(--secondary))] flex items-center justify-center overflow-hidden">
        {variant.image_base64 || product.image_base64 ? (
          <img src={variant.image_base64 || product.image_base64} alt="" className="w-full h-full object-cover" />
        ) : (
          <Package className="w-12 h-12 text-muted-foreground/60" />
        )}
      </div>
      <div className="p-4 space-y-2">
        <div className="lb-overline">
          {product.category}
          {product.subcategory ? ` · ${product.subcategory}` : ""}
        </div>
        <h3 className="font-display text-lg leading-tight" data-testid={`variant-name-${variant.id}`}>{variant.name}</h3>
        <div className="text-xs text-muted-foreground">{product.name}</div>
        <div className="pt-1 font-display text-2xl text-[hsl(var(--primary))]" data-testid={`variant-price-${variant.id}`}>
          {format(variant.sale_price)}
        </div>
        <Button
          asChild
          className="w-full rounded-full bg-[hsl(var(--accent))] hover:bg-[#C48A1E] text-white font-semibold"
          data-testid={`whatsapp-cta-variant-${variant.id}`}
        >
          <a href={buildWaLink()} target="_blank" rel="noreferrer noopener">
            <MessageCircle className="w-4 h-4 mr-2" /> Encomendar via WhatsApp
          </a>
        </Button>
      </div>
    </article>
  );
}
